import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import Container from "components/Container";
import { useTranslation } from "react-i18next";
import CustomContainer from "views/Container/CustomContainer";

const TeacherList = () => {
  const { t } = useTranslation();
  const teachers = t("teacher:teachers", { returnObjects: true });
  return (
    <CustomContainer container={true}>
      <Container>
        <Grid container spacing={2} justifyContent="center">
          {teachers.map((teacher, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Card sx={{ width: "100%", padding: 2 }}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <img
                    src={`${teacher.picture}`}
                    alt={teacher.name}
                    style={{
                      width: "100%",
                      height: "400px",
                      objectFit: "cover",
                      marginBottom: "16px",
                    }}
                  />
                  <CardContent>
                    <Typography variant="h6">{teacher.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {teacher.description}
                    </Typography>
                  </CardContent>
                  <Box>
                    <IconButton
                      color="primary"
                      component="a"
                      href={teacher.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FacebookIcon />
                    </IconButton>
                    <IconButton
                      color="primary"
                      component="a"
                      href={teacher.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <InstagramIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </CustomContainer>
  );
};
export default TeacherList;
